import { ORDER_MODEL_KEY } from 'models/daos/order/constants/index.cjs'
import getValueReduxUtil from 'modules/redux/utils/get-value'

function getShippingLabelOrderUtil (instance) {
  return getValueReduxUtil(instance, ORDER_MODEL_KEY.SHIPPING_LABEL)
}

function hasShippingLabelOrderUtil (instance) {
  return getShippingLabelOrderUtil(instance)
}

export {
  getShippingLabelOrderUtil,
  hasShippingLabelOrderUtil
}
